import { observable, computed, decorate } from 'mobx';

class ConsentsStore {
  consents = {};

  constructor() {
    document.addEventListener('bm:save', this.onConsentsChanged);
    this.consents = this.fetchConsents() || {};
  }

  fetchConsents() {
    const consentsKey = window.consentsKey || 'cookie_consent';
    const consentsString = localStorage.getItem(consentsKey);
    return consentsString ? JSON.parse(consentsString) : undefined;
  }

  get isGranted() {
    return key => (this.consents[key] ? this.consents[key] : false);
  }

  onConsentsChanged = event => {
    this.consents = event.detail.data || {};
  };

  dispose() {
    document.removeEventListener('bm:save', this.onConsentsChanged);
  }
}

decorate(ConsentsStore, {
  consents: observable,
  isGranted: computed
});

export default new ConsentsStore();



// WEBPACK FOOTER //
// ./src/stores/Consents.store.js